import { useState } from 'react';

//Component
import { InputLabel, Select, MenuItem, Button, FormControl, OutlinedInput } from '@mui/material';

//Hook
import { useRemoveJudgeFromRubricMutation } from '../../redux';
import { useEnqueueStacks } from '../../hooks/use-enqueue-stacks';

//Css
import styled from 'styled-components';

const Root = styled.div`
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: ${props => (props.groupElements ? 'wrap' : 'nowrap')};
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
`;
const Subtitle = styled.div`
  font-size: 14px;
  padding-top: 1%;
  padding-bottom: 1%;
`;

export const RemoveJudgeRubric = props => {
  const { obj, handleClose } = props;
  const element = JSON.parse(obj);
  const [judges, setJudges] = useState([]);
  const [removeJudgeFromRubric] = useRemoveJudgeFromRubricMutation();
  const { enqueueSuccess, enqueueError } = useEnqueueStacks();

  const handleChange = e => {
    setJudges(e.target.value);
  };

  const handleSubmit = async () => {
    judges.forEach(async judge => {
      const selectedJudge = element.assignedJudge.find(assignedJudge => {
        return assignedJudge._id === judge;
      });
      const res = await removeJudgeFromRubric({ rubricId: element._id, userId: judge });

      if (!res.error) {
        enqueueSuccess(`El juez ${selectedJudge.fullname} fue eliminado del Rubro de forma exitosa`, {
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else {
        enqueueError(`Ha ocurrido un error, intente mas tarde o comunicarse con el administrador`, {
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    });

    handleClose();
  };

  return (
    <Root>
      <Title>Eliminar Juez de Rubrica</Title>
      <Subtitle>Seleccione el juez para eliminarlo de la rubrica</Subtitle>
      <Row>
        <FormControl sx={{ m: 1, width: '80%' }}>
          <InputLabel id='judge-label'>Judge</InputLabel>
          <Select
            labelId='judge-label'
            id='judge'
            multiple
            value={judges}
            onChange={handleChange}
            input={<OutlinedInput label='Judge' />}
            fullWidth
            size='large'
          >
            {element.assignedJudge.map(judge => (
              <MenuItem key={judge._id} value={judge._id}>
                {judge.fullname}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          type='submit'
          variant='contained'
          size='medium'
          sx={{ height: '50px', marginTop: '1%' }}
          onClick={handleSubmit}
        >
          Eliminar
        </Button>
      </Row>
    </Root>
  );
};
